import { create_instance } from '../init';

class CashBack {
    getCashBackSettings() {
        return create_instance.get('/cashback/settings');
    }
    getCashback() {
        return create_instance.get('/cashback');
    }
    requestCashback(data) {
        return create_instance.post('/cashback', data);
    }
}

export default new CashBack();
